var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',{attrs:{"type":"flex","class-name":"lang-sample-row"}},[_c('Col',{attrs:{"span":"12"}},[_c('selectSample')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }